import * as React from 'react'
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'
import { CountryCode } from 'libphonenumber-js'
import { useCountryList } from 'hooks'

const PhoneNumberInput: React.FC<Props> = ({ phone, defaultCountry, name }) => {
  const { countries } = useCountryList({ query: 'Supported' })
  const [phoneNumber, setPhoneNumber] = React.useState<string>(phone)
  const parsedNumber = parsePhoneNumber(phone || '')
  const [dialingCode, setDialingCode] = React.useState<string>(
    `+${parsedNumber?.countryCallingCode || ''}`
  )
  const [nationalNumber, setNationalNumber] = React.useState<string>(
    parsedNumber?.nationalNumber || ''
  )
  return (
    countries.length && (
      <>
        <input
          type="hidden"
          name={`${name}[dialing_code]`}
          value={dialingCode}
        />
        <input
          type="hidden"
          name={`${name}[phone_number]`}
          value={nationalNumber}
        />
        <PhoneInput
          placeholder="0000000000"
          countries={countries.map((c) => c.code) as CountryCode[]}
          value={phoneNumber}
          onChange={(e: string) => {
            const parsedNumber = parsePhoneNumber(e || '')
            setDialingCode(`+${parsedNumber?.countryCallingCode || ''}`)
            setNationalNumber(parsedNumber?.nationalNumber || '')
            setPhoneNumber(e)
          }}
          smartCaret
          defaultCountry={defaultCountry as CountryCode}
        />
      </>
    )
  )
}

export default PhoneNumberInput

interface Props {
  phone: string
  defaultCountry: string
  name: string
}
